module.exports = __webpack_public_path__ + "static/OmniHotels.786f495d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OmniHotels.svg
// module id = 432
// module chunks = 35783957827783